import React, { FC, useState, useEffect } from "react";
import { getUserData } from "../../services/user";
import "./index.scss";

interface Props {
  isVisible?: boolean;
}

interface IUserData {
  nativeGivenName: string;
  nativeFamilyName: string;
}

const icons = {
  user: (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.61988 0.300049C5.64988 0.300049 6.47988 1.13005 6.47988 2.16005C6.47988 3.19005 5.64988 4.02005 4.61988 4.02005C3.58988 4.02005 2.75988 3.19005 2.75988 2.16005C2.75988 1.14005 3.58988 0.310049 4.60988 0.310049L4.61988 0.300049ZM8.36988 7.73005H0.879883V6.86005C0.879883 5.62005 3.35988 4.94005 4.62988 4.94005C5.89988 4.94005 8.37988 5.62005 8.37988 6.86005V7.73005H8.36988Z"
        fill="white"
      />
    </svg>
  ),
  login: (
    <svg
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8334 25L27.8334 21M27.8334 21L23.8334 17M27.8334 21H19.8334M14.5001 17.6667H8.50009C6.63933 17.6667 5.70895 17.6667 4.95189 17.8963C3.24735 18.4134 1.91347 19.7473 1.3964 21.4518C1.16675 22.2089 1.16675 23.1393 1.16675 25M17.8334 7C17.8334 10.3137 15.1471 13 11.8334 13C8.51971 13 5.83341 10.3137 5.83341 7C5.83341 3.68629 8.51971 1 11.8334 1C15.1471 1 17.8334 3.68629 17.8334 7Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  profile: (
    <svg
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5001 17.6667H8.50009C6.63933 17.6667 5.70895 17.6667 4.95189 17.8963C3.24735 18.4134 1.91347 19.7473 1.3964 21.4518C1.16675 22.2089 1.16675 23.1393 1.16675 25M17.8334 7C17.8334 10.3137 15.1471 13 11.8334 13C8.51971 13 5.83341 10.3137 5.83341 7C5.83341 3.68629 8.51971 1 11.8334 1C15.1471 1 17.8334 3.68629 17.8334 7ZM13.1667 25L17.3019 23.8185C17.4999 23.762 17.5989 23.7337 17.6913 23.6913C17.7733 23.6536 17.8512 23.6077 17.924 23.5543C18.0059 23.4942 18.0787 23.4214 18.2243 23.2758L26.8335 14.6667C27.754 13.7462 27.754 12.2538 26.8335 11.3333C25.913 10.4128 24.4206 10.4128 23.5001 11.3333L14.891 19.9424C14.7453 20.0881 14.6725 20.1609 14.6124 20.2428C14.559 20.3155 14.5131 20.3935 14.4755 20.4755C14.4331 20.5678 14.4048 20.6668 14.3482 20.8649L13.1667 25Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  settings: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="50px"
      height="50px"
    >
      <path
        d="M 22.205078 2 A 1.0001 1.0001 0 0 0 21.21875 2.8378906 L 20.246094 8.7929688 C 19.076509 9.1331971 17.961243 9.5922728 16.910156 10.164062 L 11.996094 6.6542969 A 1.0001 1.0001 0 0 0 10.708984 6.7597656 L 6.8183594 10.646484 A 1.0001 1.0001 0 0 0 6.7070312 11.927734 L 10.164062 16.873047 C 9.583454 17.930271 9.1142098 19.051824 8.765625 20.232422 L 2.8359375 21.21875 A 1.0001 1.0001 0 0 0 2.0019531 22.205078 L 2.0019531 27.705078 A 1.0001 1.0001 0 0 0 2.8261719 28.691406 L 8.7597656 29.742188 C 9.1064607 30.920739 9.5727226 32.043065 10.154297 33.101562 L 6.6542969 37.998047 A 1.0001 1.0001 0 0 0 6.7597656 39.285156 L 10.648438 43.175781 A 1.0001 1.0001 0 0 0 11.927734 43.289062 L 16.882812 39.820312 C 17.936999 40.39548 19.054994 40.857928 20.228516 41.201172 L 21.21875 47.164062 A 1.0001 1.0001 0 0 0 22.205078 48 L 27.705078 48 A 1.0001 1.0001 0 0 0 28.691406 47.173828 L 29.751953 41.1875 C 30.920633 40.838997 32.033372 40.369697 33.082031 39.791016 L 38.070312 43.291016 A 1.0001 1.0001 0 0 0 39.351562 43.179688 L 43.240234 39.287109 A 1.0001 1.0001 0 0 0 43.34375 37.996094 L 39.787109 33.058594 C 40.355783 32.014958 40.813915 30.908875 41.154297 29.748047 L 47.171875 28.693359 A 1.0001 1.0001 0 0 0 47.998047 27.707031 L 47.998047 22.207031 A 1.0001 1.0001 0 0 0 47.160156 21.220703 L 41.152344 20.238281 C 40.80968 19.078827 40.350281 17.974723 39.78125 16.931641 L 43.289062 11.933594 A 1.0001 1.0001 0 0 0 43.177734 10.652344 L 39.287109 6.7636719 A 1.0001 1.0001 0 0 0 37.996094 6.6601562 L 33.072266 10.201172 C 32.023186 9.6248101 30.909713 9.1579916 29.738281 8.8125 L 28.691406 2.828125 A 1.0001 1.0001 0 0 0 27.705078 2 L 22.205078 2 z M 23.056641 4 L 26.865234 4 L 27.861328 9.6855469 A 1.0001 1.0001 0 0 0 28.603516 10.484375 C 30.066026 10.848832 31.439607 11.426549 32.693359 12.185547 A 1.0001 1.0001 0 0 0 33.794922 12.142578 L 38.474609 8.7792969 L 41.167969 11.472656 L 37.835938 16.220703 A 1.0001 1.0001 0 0 0 37.796875 17.310547 C 38.548366 18.561471 39.118333 19.926379 39.482422 21.380859 A 1.0001 1.0001 0 0 0 40.291016 22.125 L 45.998047 23.058594 L 45.998047 26.867188 L 40.279297 27.871094 A 1.0001 1.0001 0 0 0 39.482422 28.617188 C 39.122545 30.069817 38.552234 31.434687 37.800781 32.685547 A 1.0001 1.0001 0 0 0 37.845703 33.785156 L 41.224609 38.474609 L 38.53125 41.169922 L 33.791016 37.84375 A 1.0001 1.0001 0 0 0 32.697266 37.808594 C 31.44975 38.567585 30.074755 39.148028 28.617188 39.517578 A 1.0001 1.0001 0 0 0 27.876953 40.3125 L 26.867188 46 L 23.052734 46 L 22.111328 40.337891 A 1.0001 1.0001 0 0 0 21.365234 39.53125 C 19.90185 39.170557 18.522094 38.59371 17.259766 37.835938 A 1.0001 1.0001 0 0 0 16.171875 37.875 L 11.46875 41.169922 L 8.7734375 38.470703 L 12.097656 33.824219 A 1.0001 1.0001 0 0 0 12.138672 32.724609 C 11.372652 31.458855 10.793319 30.079213 10.427734 28.609375 A 1.0001 1.0001 0 0 0 9.6328125 27.867188 L 4.0019531 26.867188 L 4.0019531 23.052734 L 9.6289062 22.117188 A 1.0001 1.0001 0 0 0 10.435547 21.373047 C 10.804273 19.898143 11.383325 18.518729 12.146484 17.255859 A 1.0001 1.0001 0 0 0 12.111328 16.164062 L 8.8261719 11.46875 L 11.523438 8.7734375 L 16.185547 12.105469 A 1.0001 1.0001 0 0 0 17.28125 12.148438 C 18.536908 11.394293 19.919867 10.822081 21.384766 10.462891 A 1.0001 1.0001 0 0 0 22.132812 9.6523438 L 23.056641 4 z M 25 17 C 20.593567 17 17 20.593567 17 25 C 17 29.406433 20.593567 33 25 33 C 29.406433 33 33 29.406433 33 25 C 33 20.593567 29.406433 17 25 17 z M 25 19 C 28.325553 19 31 21.674447 31 25 C 31 28.325553 28.325553 31 25 31 C 21.674447 31 19 28.325553 19 25 C 19 21.674447 21.674447 19 25 19 z"
        fill="currentColor"
      />
    </svg>
  ),
  logout: (
    <svg
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 23.8334 25 L 20 21 M 20 21 L 24 17 M 28 21 H 19.8334 M 14.5001 17.6667 H 8.5001 C 6.6393 17.6667 5.7089 17.6667 4.9519 17.8963 C 3.2473 18.4134 1.9135 19.7473 1.3964 21.4518 C 1.1667 22.2089 1.1667 23.1393 1.1667 25 M 17.8334 7 C 17.8334 10.3137 15.1471 13 11.8334 13 C 8.5197 13 5.8334 10.3137 5.8334 7 C 5.8334 3.6863 8.5197 1 11.8334 1 C 15.1471 1 17.8334 3.6863 17.8334 7 Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
};

const guestLinks = [
  {
    icon: icons["login"],
    target: "_self",
    path: `/signin?returnPath=${window.location.pathname.slice(1)}${
      window.location.search
    }${window.location.search.length ? "&" : "?"}status=logged`,
    title: "Sign In",
    slug: "login",
    className: ""
  },
  {
    icon: icons["profile"],
    target: "_self",
    path: "#",
    slug: "register",
    title: "Create an account",
    className: "sign-up__trigger-form"
  }
];

const userLinks = [
  {
    icon: icons["settings"],
    target: "_blank",
    path: process.env.TENNIS_ID_HOST,
    title: "Manage account",
    slug: "manage_account",
    className: ""
  },
  {
    icon: icons["logout"],
    target: "_self",
    path: "/logout",
    title: "Sign out",
    slug: "logout",
    className: ""
  }
];

const STORAGE_KEY = "userData";

export const toggleMyAccount = () => {
  const navBtn = document.getElementsByClassName("tennisid_nav");
  const navContainer = document.getElementById("my-account");
  if (navBtn.length > 0) {
    Array.from(navBtn).forEach(element => {
      element.classList.toggle("visible");
    });
  }
  navContainer && navContainer.classList.toggle("visible");
};

const MyAccount: FC<Props> = ({ isVisible = true }) => {
  const [isAuth, setIsAuth] = useState(false);
  const [userData, setUserData] = useState<IUserData | undefined>();
  const list = isAuth ? userLinks : guestLinks;

  useEffect(() => {
    const userData = localStorage.getItem(STORAGE_KEY);
    if (userData) {
      const data = JSON.parse(userData);
      if (data && data.nativeGivenName) {
        setUserData(data);
        setIsAuth(true);
      } else {
        localStorage.removeItem(STORAGE_KEY);
        setIsAuth(false);
        setUserData(undefined);
      }
    } else {
      if (window.location.href.includes("status=logged")) {
        getUserData().then((response: IUserData) => {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(response));
          setUserData(response);
          setIsAuth(true);
        });
      }
    }
  }, []);

  return isVisible ? (
    <div className="my-account">
      <div className="my-account__account">
        <a
          href=""
          className={`my-account__account--btn ${
            isAuth ? "logged" : "not-logged"
          }`}
          onClick={e => {
            e.preventDefault();
          }}
        >
          <i>
            {!isAuth ? icons["user"] : <div className="icon-profile"></div>}
          </i>
          <span>
            {isAuth && userData
              ? `Hello, ${userData.nativeGivenName}`
              : "MY ACCOUNT"}
          </span>
        </a>
        <div className="my-account__account--nav">
          {list.map(({ icon, path, title, className, slug, target }, key) => (
            <a
              href={path}
              target={target}
              key={`${path}-${key}`}
              className={className}
              onClick={() => {
                if (slug === "register") {
                  toggleMyAccount();
                }
                if (slug === "logout") {
                  setUserData(undefined);
                  setIsAuth(false);
                  localStorage.removeItem(STORAGE_KEY);
                }
              }}
            >
              <i>{icon}</i>
              <span>{title}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default MyAccount;
